<template>
  <v-container class="container-card">
    <v-card>
      <TabelaGrupoEmpresa />
    </v-card>
  </v-container>
</template>

<script>
import { mapActions } from "vuex";
export default {
  name: "ConsultaGrupoEmpresa",

  components: {
    TabelaGrupoEmpresa: () =>
      import("@/components/empresa/grupoEmpresa/TabelaGrupoEmpresa")
  },

  methods: {
    ...mapActions({
      fetchView: "sistema/fetchView"
    })
  },

  mounted() {
    this.fetchView("Consulta Grupo Empresa");
  }
};
</script>
